import { useMemo } from 'react';

import { Button } from '@hivebrite/design-system/Button';

import LoginWrapper from 'hb-react/frontoffice/components/LoginWrapper';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';
import { useIsLoginRequired } from 'hb-react/shared/apps/Events/hooks/useIsLoginRequired';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

const RegistrationButtonV1 = () => {
  const { eventRegistrationPageLink, event } = useEventContext();

  const { currentUser } = useDefaultAppContexts();

  if (event.tickets.length === 0) {
    return null;
  }

  const shouldLogIn =
    !currentUser &&
    event.tickets.every(({ internal_ticket: should }) => should);

  if (shouldLogIn) {
    return <LoginWrapper redirectTo={eventRegistrationPageLink} />;
  }

  return (
    <Button
      dataTestId="event-registration"
      onClick={() => window.location.assign(eventRegistrationPageLink)}
    >
      {I18n.t('web.networks.events.show.join')}
    </Button>
  );
};

const REGISTRATION_STATE_TO_LABEL = {
  fully_booked: s__('Events|Fully booked'),
  limit_reached_for_current_user: s__('Events|Ticket limit reached'),
  opens_soon: s__('Events|Registration opens soon'),
  closed: s__('Events|Registration closed'),
  restricted: s__('Events|Registration closed'),
  open: I18n.t('web.networks.events.show.join'),
};

const RegistrationButtonV2 = () => {
  const { eventRegistrationPageLink, event } = useEventContext();

  const shouldDisplayLogInButton = useIsLoginRequired(event);

  const [label, props] = useMemo(() => {
    if (event.participation_type !== 'tickets' || !event.registration_status) {
      return [];
    }

    const label = REGISTRATION_STATE_TO_LABEL[event.registration_status];

    return [
      label,
      event.registration_status === 'open'
        ? { onClick: () => window.location.assign(eventRegistrationPageLink) }
        : { isDisabled: true },
    ];
  }, [event, eventRegistrationPageLink]);

  if (shouldDisplayLogInButton) {
    return <LoginWrapper redirectTo={eventRegistrationPageLink} />;
  }

  if (!label) {
    return null;
  }

  return (
    <Button dataTestId="event-registration" {...props}>
      {label}
    </Button>
  );
};

export const RegistrationButton = () => {
  const { flagEvImproveSoldOutEventsFo } = useFeatureFlag();

  if (flagEvImproveSoldOutEventsFo) {
    return <RegistrationButtonV2 />;
  }

  return <RegistrationButtonV1 />;
};
